import { render, staticRenderFns } from "./Zeitkontoangaben.vue?vue&type=template&id=0164ff00&"
import script from "./Zeitkontoangaben.vue?vue&type=script&lang=js&"
export * from "./Zeitkontoangaben.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports